// Tenant "show prices inclusive of tax" display flag for POS pages.
//
// Single source of truth is the OWNER-managed tenant setting
// (`tenants.show_tax_inclusive`, edited in Admin › Tax Configuration). It is
// delivered to every role through `/auth/me` and mirrored into the offline
// `app_config` row so an offline reload keeps the same catalogue display.
//
// This is a PRESENTATION flag only: product prices are always the tax-
// exclusive base and the payable total is always base + tax. The flag decides
// whether tiles/cart lines show the base or the tax-inclusive figure.

import { useEffect, useState } from 'react';
import { useAuthStore } from '@/stores/use-auth-store';
import { getCachedTenantTaxInclusive } from '@/db/pos-database';

export function useTaxInclusive(): boolean {
  const fromProfile = useAuthStore((s) => s.profile?.tenant?.show_tax_inclusive);
  const [cached, setCached] = useState(false);

  useEffect(() => {
    if (fromProfile !== undefined) return;
    let cancelled = false;
    getCachedTenantTaxInclusive()
      .then((v) => { if (!cancelled) setCached(v); })
      .catch(() => { /* no cache yet — default to exclusive display */ });
    return () => { cancelled = true; };
  }, [fromProfile]);

  return fromProfile ?? cached;
}
